// @flow
import i18next from 'app/i18n';


export default () => ({
  lk: {
    id: 'lk',
    title: i18next.t('tariff:informer_lk'),
    enabled: true,
    checked: true,
  },
  mobile: {
    id: 'mobile',
    title: i18next.t('tariff:informer_mobile'),
    enabled: true,
    checked: true,
  },
  sms: {
    id: 'sms',
    title: i18next.t('tariff:informer_sms'),
    enabled: true,
    checked: true,
  },
  email: {
    id: 'email',
    title: i18next.t('tariff:informer_email'),
    enabled: true,
    checked: true,
  },
});

export type Inform = {
  id: string,
  title: string,
  enabled: boolean,
  checked: boolean,
};
